import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function MoveToDialog({ open, onOpenChange, item, titles, currentTitleId, onSubmit }) {
  const [busy, setBusy] = useState(false);
  const [pickedId, setPickedId] = useState(null);

  if (!item) return null;
  const options = (titles || []).filter((t) => t.title_id !== currentTitleId);

  const handleMove = async (target_id) => {
    if (busy) return;
    setBusy(true);
    setPickedId(target_id);
    try {
      await onSubmit(target_id);
      onOpenChange(false);
    } finally {
      setBusy(false);
      setPickedId(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="move-to-dialog"
        className="bg-[#121212] border-[#27272A] text-[#F3F4F6] max-w-md p-0 overflow-hidden"
      >
        <DialogHeader className="px-5 pt-5 pb-3 border-b border-[#27272A]">
          <DialogTitle className="font-heading text-base">Move to another note</DialogTitle>
        </DialogHeader>

        <div className="max-h-[60vh] overflow-y-auto p-2">
          {options.length === 0 ? (
            <div className="p-6 text-center text-sm text-[#6B7280]">
              You only have one note. Create another to move items into it.
            </div>
          ) : (
            <ul className="space-y-0.5">
              {options.map((t) => (
                <li key={t.title_id}>
                  <button
                    data-testid={`move-target-${t.title_id}`}
                    disabled={busy}
                    onClick={() => handleMove(t.title_id)}
                    className="group w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-[#F3F4F6] hover:bg-[#1E1E1E] transition-all disabled:opacity-60"
                  >
                    <div
                      className="h-9 w-9 rounded-full flex items-center justify-center text-xs font-semibold text-white shrink-0"
                      style={{ background: `linear-gradient(135deg, ${t.color}, ${t.color}99)` }}
                    >
                      {t.name?.[0]?.toUpperCase() || "T"}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-medium truncate">{t.name}</div>
                      <div className="text-[11px] text-[#6B7280] truncate">
                        {t.item_count || 0} items
                      </div>
                    </div>
                    <ArrowRight
                      className={`h-4 w-4 shrink-0 transition-opacity ${
                        pickedId === t.title_id ? "opacity-100 text-[#3B82F6]" : "opacity-0 group-hover:opacity-100 text-[#9CA3AF]"
                      }`}
                    />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <DialogFooter className="px-5 py-3 border-t border-[#27272A]">
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            variant="ghost"
            className="rounded-full text-[#9CA3AF] hover:text-[#F3F4F6] hover:bg-[#1E1E1E]"
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
